import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { formatText } from '../../../../helpers/value'

export const TitleChart = ({ rowGroupId, selectRowGroup }) => {
  const rowGroup = useSelector(selectRowGroup(rowGroupId))

  const companyItem =
    rowGroup.find((item) => item.organizationType === 'Company') || {}

  return (
    <>
      {formatText(companyItem.ratioName)}&nbsp;
      {companyItem.ratioName && (
        <Translate value="companyAnalysis.industryAnalysis.OVER_5_YEARS" />
      )}
    </>
  )
}
